import {FC} from 'react'

// demo component without title defined
const VendorAdd: FC = () => {
  return (
    // html starts here
    <div>
      <h3>How to create a new vendor</h3>
      <p>
        Fill the fields with appropriate data and click the create button located at the end of the
        form. Your vendor has been created.
      </p>
    </div>
    // html ends here
  )
}

export default VendorAdd
